import React from "react";
import ServiceDetailSection from "./ServiceDetailSection";
import { SectionContainerBase, ButtonBase } from "@reusejs/react";
import { CheckIcon } from "@heroicons/react/outline";
import ExpertConsultationImageSvg from "../../Icons/ExpertConsultationImageSvg";
import FinancingAssistanceImageSvg from "../../Icons/FinancingAssistanceImageSvg";
import DedicatedRelationshipManagersImageSvg from "../../Icons/DedicatedRelationshipManagersImageSvg";

const FooterActions = () => {
  return (
    <div className="mt-5 lg:mt-8 flex items-center">
      <div className="w-full md:w-[initial] flex items-center md:items-[initial]">
        <div className="mr-2 w-full md:w-[initial]">
          <ButtonBase
            variant="primary"
            type="submit"
            label="Request service"
            onClick={() => {
              console.log("button clicked");
            }}
            buttonBaseClasses={{
              font: "text-sm font-medium",
              backgroundColor: "bg-blue-600 hover:bg-blue-700",
              textColor: "text-white",
              border: "any",
              padding: "md:px-4 py-3",
              width: "w-full md:w-[initial]",
            }}
          />
        </div>
        <ButtonBase
          variant="primary"
          type="submit"
          label="Learn more"
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-transparent",
            textColor: "text-black hover:text-blue-700",
            border: "border border-black border hover:border-blue-700",
            padding: "px-4 py-2.5",
            width: "w-full md:w-[initial]",
          }}
        />
      </div>
    </div>
  );
};

const SectionItemsIcon = () => {
  return <CheckIcon className="text-green-600 h-5 w-5 p-0.5" />;
};

let services = {
  expert_consultation: {
    imgPattern: "bg-expert-consultation-pattern",
    imgUrl: "/expertConsultation.png",
    svgElement: <ExpertConsultationImageSvg />,
    section_heading: "Expert Consultation",
    section_description:
      "We will be one point of contact for all the interested investors in auction properties starting from EMD payment till Registration of the property.",
    section_items: [
      {
        icon: <SectionItemsIcon />,
        title: "Document Analysis",
      },
      {
        icon: <SectionItemsIcon />,
        title: "Technical/Physical Verification",
      },
      {
        icon: <SectionItemsIcon />,
        title: "Document Writing",
      },
      {
        icon: <SectionItemsIcon />,
        title: "Price Analysis",
      },
    ],
  },
  financing_assistance: {
    imgPattern: "bg-financing-assistance-pattern",
    imgUrl: "/financingAssistance.png",
    svgElement: <FinancingAssistanceImageSvg />,
    section_heading: "Financing Assistance",
    section_description:
      "As a practice, the financial institution does not fund for auction properties / NPA property take over. We have exclusively partnered with NBFC/FI’s/Banks to facilitate funding of NPA’s smoothly.",
    section_items: [
      {
        icon: <SectionItemsIcon />,
        title: "Client Profiling",
        actions: <p>Actions</p>,
      },
      {
        icon: <SectionItemsIcon />,
        title: "Bridge Financing",
        actions: <p>Actions</p>,
      },
      {
        icon: <SectionItemsIcon />,
        title: "Mortgage Financing",
        actions: <p>Actions</p>,
      },
      {
        icon: <SectionItemsIcon />,
        title: "Unsecured Lending",
        actions: <p>Actions</p>,
      },
    ],
  },
  dedicated_relationship_managers: {
    imgPattern: "bg-dedicated_relationship_managers-pattern",
    imgUrl: "/dedicatedRelationshipManagers.png",
    svgElement: <DedicatedRelationshipManagersImageSvg />,
    section_heading: "Dedicated Relationship Managers",
    section_description:
      "We assign a dedicated relationship manager for end-to-end handling transactions. Right from selecting the property from the database to consulting services in auction management.",
    section_items: [
      {
        icon: <SectionItemsIcon />,
        title: "Identification of Property",
        actions: <p>Actions</p>,
      },
      {
        icon: <SectionItemsIcon />,
        title: "Acquiring of Property",
        actions: <p>Actions</p>,
      },
      {
        icon: <SectionItemsIcon />,
        title: "Disposal of Property",
        actions: <p>Actions</p>,
      },
      {
        icon: <SectionItemsIcon />,
        title: "Wealth Management",
        actions: <p>Actions</p>,
      },
    ],
  },
};

export default function ServicesSection() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-0",
      }}
    >
      <div className="mb-10 md:mb-20" id="expert-consulting">
        <ServiceDetailSection
          sectionHeading={services.expert_consultation.section_heading}
          sectionDescription={services.expert_consultation.section_description}
          sectionItems={services.expert_consultation.section_items}
          reverseFlexDirection={false}
          footerActions={<FooterActions />}
          imgPattern={services.expert_consultation.imgPattern}
          imgUrl={services.expert_consultation.imgUrl}
          svgElement={services.expert_consultation.svgElement}
        />
      </div>

      <div className="mb-10 md:mb-20" id="financing-assistance">
        <ServiceDetailSection
          sectionHeading={services.financing_assistance.section_heading}
          sectionDescription={services.financing_assistance.section_description}
          sectionItems={services.financing_assistance.section_items}
          reverseFlexDirection={true}
          footerActions={<FooterActions />}
          imgPattern={services.financing_assistance.imgPattern}
          imgUrl={services.financing_assistance.imgUrl}
          svgElement={services.financing_assistance.svgElement}
        />
      </div>

      <div id="dedicated-relationship-manager">
        <ServiceDetailSection
          sectionHeading={
            services.dedicated_relationship_managers.section_heading
          }
          sectionDescription={
            services.dedicated_relationship_managers.section_description
          }
          sectionItems={services.dedicated_relationship_managers.section_items}
          flexDirection="row"
          reverseFlexDirection={false}
          footerActions={<FooterActions />}
          imgPattern={services.dedicated_relationship_managers.imgPattern}
          imgUrl={services.dedicated_relationship_managers.imgUrl}
          svgElement={services.dedicated_relationship_managers.svgElement}
        />
      </div>
    </SectionContainerBase>
  );
}
